export const languages = [
  { code: 'en', name: 'English', nativeName: 'English', dir: 'ltr' },
  { code: 'hi', name: 'Hindi', nativeName: 'हिन्दी', dir: 'ltr' },
  { code: 'es', name: 'Spanish', nativeName: 'Español', dir: 'ltr' },
  { code: 'zh-CN', name: 'Chinese (Simplified)', nativeName: '简体中文', dir: 'ltr' },
  { code: 'ar', name: 'Arabic', nativeName: 'العربية', dir: 'rtl' },
  { code: 'fr', name: 'French', nativeName: 'Français', dir: 'ltr' },
  { code: 'pt', name: 'Portuguese', nativeName: 'Português', dir: 'ltr' },
  { code: 'bn', name: 'Bengali', nativeName: 'বাংলা', dir: 'ltr' },
  { code: 'ru', name: 'Russian', nativeName: 'Русский', dir: 'ltr' },
  { code: 'de', name: 'German', nativeName: 'Deutsch', dir: 'ltr' },
  { code: 'ja', name: 'Japanese', nativeName: '日本語', dir: 'ltr' },
  { code: 'ko', name: 'Korean', nativeName: '한국어', dir: 'ltr' },
  { code: 'tr', name: 'Turkish', nativeName: 'Türkçe', dir: 'ltr' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt', dir: 'ltr' },
  { code: 'it', name: 'Italian', nativeName: 'Italiano', dir: 'ltr' },
  { code: 'th', name: 'Thai', nativeName: 'ไทย', dir: 'ltr' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands', dir: 'ltr' },
  { code: 'pl', name: 'Polish', nativeName: 'Polski', dir: 'ltr' },
  { code: 'ur', name: 'Urdu', nativeName: 'اردو', dir: 'rtl' },
  { code: 'id', name: 'Indonesian', nativeName: 'Bahasa Indonesia', dir: 'ltr' },
] as const;

export type LanguageCode = (typeof languages)[number]['code'];

export const DEFAULT_LANGUAGE: LanguageCode = 'en';

export function getLanguageFromPath(pathname: string): LanguageCode {
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  const match = languages.find(
    (language) => language.code.toLowerCase() === firstSegment?.toLowerCase()
  );
  return match?.code ?? DEFAULT_LANGUAGE;
}

export function getPathWithoutLanguage(pathname: string): string {
  const segments = pathname.split('/').filter(Boolean);
  const firstSegment = segments[0];
  const isLanguagePrefix = languages.some(
    (language) => language.code.toLowerCase() === firstSegment?.toLowerCase()
  );
  if (isLanguagePrefix) segments.shift();
  return segments.length ? `/${segments.join('/')}/` : '/';
}

export function getLocalizedPath(
  pathname: string,
  language: LanguageCode
): string {
  const cleanPath = getPathWithoutLanguage(pathname);
  if (language === DEFAULT_LANGUAGE) return cleanPath;
  return cleanPath === '/' ? `/${language}/` : `/${language}${cleanPath}`;
}